<template>
  <div>
    <div class="d-flex ma-6">
      <v-spacer></v-spacer>
      <v-btn outlined color="success" @click="exportExcelApp"> <v-icon left>mdi-file-excel</v-icon> Xuất Excel </v-btn>
    </div>
    <v-card class="mb-6 mx-6 pa-6 pb-4" outlined>
      <AppHistoryFilter @onFilterChanged="onFilterChanged" />
    </v-card>
    <v-card class="mx-6 mb-6" outlined>
      <AppHistoryDataTable ref="table" />
    </v-card>
  </div>
</template>

<script>
import AppHistoryFilter from '@/modules/post/AppHistoryFilter.vue'
import AppHistoryDataTable from '@/modules/post/AppHistoryDataTable.vue'
import utils from '@/plugins/utils'
import get from 'lodash-es/get'
import { mapState, mapActions } from 'vuex'

export default {
  components: {
    AppHistoryFilter,
    AppHistoryDataTable
  },
  data() {
    return {}
  },
  mounted() {},
  computed: {
    ...mapState('AppHistory', ['searchParams'])
  },
  methods: {
    ...mapActions('AppHistory', ['fetchHistory']),

    onFilterChanged(query) {
      this.$refs.table.refresh(query)
    },
    async exportExcelApp() {
      this.$loading.active = true
      try {
        let headers = [...this.$refs.table.headers]
        headers.splice(1, 0, {
          text: 'Mã số',
          value: 'code'
        })
        let excelHeader = headers.map(({ text, value }) => ({ text, value }))
        excelHeader = excelHeader.filter(excel => excel.value !== 'action')
        const filters = this.$refs.table.$options.filters
        const params = { ...this.searchParams }
        delete params._start
        delete params._sort
        if (params.createdAt_gte) params._sort = 'createdAt:desc'
        const list = await this.fetchHistory({ ...params, _limit: -1 })
        const histories = JSON.parse(JSON.stringify(list))
        const data = histories.map(item => {
          item.time = filters.ddmmyyyyhhmm(item.createdAt)
          item.receiver = item.student.name
          item.code = filters.getStudentCode(item.student.code)
          item.status = filters.getSendNotiStatus(item.status)
          item.currentClass = get(item.class, 'title')
          item.config = filters.getConfig(item.config)
          item.postType = filters.getPostType(item.postType)

          return item
        })
        utils.exportExcel(data, excelHeader, 'LichSuApp')
      } catch (error) {
        this.$alert.error('Đã có lỗi xảy ra: ' + error)
      } finally {
        this.$loading.active = false
      }
    }
  }
}
</script>

<style lang="scss" scoped></style>
